import {
  types,
  IMediaTypeGroup,
  MediaTypeGroupActionsType,
} from '../types/mediaTypeGroup'

export const initialState: IMediaTypeGroup = {
  isLoading: false,
  id: '',
  title: '',
  description: '',
  created: '',
  createdBy: {
    name: '',
    id: '',
  },
  types: [],
}

export const mediaTypeGroup = (
  state = initialState,
  action: MediaTypeGroupActionsType
) => {
  switch (action.type) {
    case types.CREATE_MEDIA_TYPE_GROUP__STARTED:
    case types.GET_MEDIA_TYPE_GROUP_BY_ID__STARTED:
    case types.UPDATE_MEDIA_TYPE_GROUP__STARTED:
    case types.DELETE_MEDIA_TYPE_GROUP__STARTED:
      return { ...state, isLoading: true }
    case types.CREATE_MEDIA_TYPE_GROUP__SUCCESS:
      return {
        ...state,
        isLoading: false,
        ...action.mediaTypeGroupData,
      }
    case types.CREATE_MEDIA_TYPE_GROUP__FAILURE:
    case types.UPDATE_MEDIA_TYPE_GROUP__FAILURE:
    case types.GET_MEDIA_TYPE_GROUP_BY_ID__FAILURE:
      return { ...state, isLoading: false }
    case types.DELETE_MEDIA_TYPE_GROUP__SUCCESS:
    case types.DELETE_MEDIA_TYPE_GROUP__FAILURE:
      return {
        ...state,
        isLoading: false,
        message: action.message,
      }
    case types.GET_MEDIA_TYPE_GROUP_BY_ID__SUCCESS:
    case types.UPDATE_MEDIA_TYPE_GROUP__SUCCESS:
      return {
        ...state,
        isLoading: false,
        ...action.mediaTypeGroupData,
      }
    default:
      return state
  }
}
